import { Checkbox, FormControlLabel } from "@material-ui/core";
import styles from "../../assets/styles/molecules/dontShowAgainCheckbox.module.scss";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  className?: string;
};

const DontShowAgainCheckbox = ({
  checked,
  onChange,
  label = "次回以降、この画面を表示しない",
  className,
}: Props) => {
  return (
    <FormControlLabel
      className={`${styles.container} ${className || ""}`}
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          color="primary"
          size="small"
          className={styles.checkbox}
        />
      }
      label={label}
    />
  );
};

export default DontShowAgainCheckbox;
